import { Tag, type TagProps } from 'antd';
import clx from 'classnames';
import styled from 'styled-components';

export interface IStyledTagProps extends TagProps {
  /** Variante compatta (line-height 14px, padding 4px) */
  mini?: boolean;
}

const BaseStyledTag = styled(Tag)`
  text-transform: uppercase;
  letter-spacing: 0.03em;
  line-height: 20px;
  padding-inline: 7px;
  &.mini {
    line-height: 14px;
    padding-inline: 4px;
  }
  &&& {
    font-weight: 600;
  }
`;

/**
 * Tag stilizzato per la visualizzazione di stati, tipi e categorie.
 *
 * Variante compatta con prop `mini`.
 * Accetta tutte le props di `Tag` di Ant Design.
 */
export function StyledTag({
  mini,
  className,
  ...tagProps
}: Readonly<IStyledTagProps>) {
  return <BaseStyledTag className={clx(className, { mini })} {...tagProps} />;
}
